<div class="dialog-header">
  <span class="spacer"></span>
  @if (entityId().length > 0) {
    <label class="header-label">{{ 'Scheduling/Purchasing information for ' + entityId() }}</label>
  }
  <span class="spacer"></span>
  <button class="close-dialog-button warn-button" matButton="elevated" (click)="close()">X</button>
</div>
<div class="content">
  @if (entityId().length > 0) {
    <div class="display-row">
      <span class="value-label">Scheduling Comments:</span>
      <span class="data-label">{{ schedulingComments() }}</span>
    </div>
    <div class="display-row">
      <span class="value-label">Purchasing Comments:</span>
      <span class="data-label">{{ purchasingComments() }}</span>
    </div>
  } @else {
    <div class="display-row">
      <span class="no-data-label">No Scheduling or Purchasing information found</span>
    </div>
  }
</div>
